import MedicoPersonal from "./medicoPersonal";
import Mensajes from "../../../../../base/components/mensajes";

class SedeMedicoPersonal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userInfo: {},
      configurations: {},
      key: 0,
      beneficiariesList: [],
      activeOption: null,
      loadingDoctorInfo: true,
      isDoctorAssigned: false,
      typeUser: this.props.typeUser,
      userContributor: "contributor",
      userBeneficiary: "beneficiary",
      isActivePanel: false,
      currentAlert: "",
      showBeneficiariesTab: false,
      benefiariesServiceErrorMessage: ""
    };
    this.isEmpty = this.isEmpty.bind(this);
    this.tabSelect = this.tabSelect.bind(this);
    this.getDoctorInfo = this.getDoctorInfo.bind(this);
    this.getBeneficiariesList = this.getBeneficiariesList.bind(this);
    this.handleSelectPanel = this.handleSelectPanel.bind(this);
    this.beneficiariesHandleSelect = this.beneficiariesHandleSelect.bind(this);
    this.styledTabs = this.styledTabs.bind(this);
  }

  componentDidMount(prevProps, prevState) {
    this.setState({
      userInfo: this.props.userInfo,
      configurations: this.props.configurations
    });
    this.tabSelect(1);
    this.getBeneficiariesList();
    setTimeout(() => {
      //this.styledTabs();
    }, 1000);
  }

  shouldComponentUpdate(nextProps, nextState) {
    this.setState((prevState, props) => {
      return { configurations: props.configurations };
    });
    return !this.isEmpty(nextProps.configurations);
  }

  isEmpty(obj) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  }

  tabSelect(key) {
    this.setState({ key: key }, () => {
      //this.styledTabs();
    });
  }

  getDoctorInfo(docNumber, docType, callback) {
    let service = "";
    if (this.state.typeUser === "EP") {
      service = "ObtenerSedeMedicoMiRedPBS?tipoDocumento=";
    } else {
      service = "ObtenerSedeMedicoMiRedPC?tipoDocumento=";
    }
    const doctorInfo = new ServicioProxy(
      service + docType + "&numeroDocumento=" + docNumber
    );
    doctorInfo
      .getElements("POST", {})
      .then(response => {
        const data = JSON.parse(response);
        //if(data.MedicoSede !== null || data.Sede !== null ){
        if (callback) {
          callback(data);
        }
        this.setState({ loadingDoctorInfo: false });
        if (this.props.userInfo.LegalID === docNumber) {
          this.setState({
            isDoctorAssigned:
              data.MedicoSede !== null &&
              data.MedicoSede.NumeroDocumento !== null
          });
        }
        //}else{
        //this.setState({ currentAlert: 'messages' });
        //}
      })
      .catch(error => console.log(error));
  }

  getBeneficiariesList() {
    let service = "";
    if (this.state.typeUser === "EP") {
      service = "BeneficiariosUsuarioPBS?tipoDocumento=";
    } else {
      service = "BeneficiariosUsuarioPC?tipoDocumento=";
    }
    const beneficiaries = new ServicioProxy(
      service +
        this.props.userInfo.TipoIdentificacion +
        "&numeroDocumento=" +
        this.props.userInfo.LegalID
    );

    beneficiaries
      .getElements("POST", {})
      .then(response => {
        let data = JSON.parse(response);

        /*
      //Data para probar respuesta del servicio
      data = {
        "Beneficiarios": [],
        "Error": {
            "CodigoStatusError": "401",
            "MensajeError": "The remote server was not found: (401) Not found."
        }
      }*/

        if (data.Error !== null) {
          this.setState({
            showBeneficiariesTab: true,
            benefiariesServiceErrorMessage: this.props.configurations[
              "MensajeErrorServicioBeneficiarios"
            ]
          });
        } else if (data.Error === null && data.Beneficiarios !== null) {
          this.setState({
            beneficiariesList: data.Beneficiarios,
            showBeneficiariesTab: data.Beneficiarios.length > 0 ? true : false
          });
        } else {
          this.setState({ currentAlert: "messages" });
        }
      })
      .catch(error => console.error(error));
  }

  handleSelectPanel(activeKey) {
    this.setState({
      activeOption: activeKey,
      isActivePanel: !this.state.isActivePanel
    });
  }

  beneficiariesHandleSelect(activeOption) {
    this.setState({ activeOption });
  }

  styledTabs() {
    const width = window.innerWidth;
    const tabs = document.querySelector("#doctor-tabs ul.nav.nav-tabs");
    const tabList = tabs.getElementsByTagName("li");
    if (width <= 760) {
      if (tabList.length === 1) {
        //tabList[0].style.cssText = 'float:none;width: 50%;';
      } else {
        const item1 = tabList[1].childNodes;
        const item0 = tabList[0].childNodes;
        if (this.state.key === 1) {
          tabList[0].style.cssText = "width: 60%; left: 20%;";
          tabList[1].style.cssText = "width: 20%; right: 0%";
          item1[0].textContent = " ";
          item1[0].innerHTML =
            '<i class="fa fa-chevron-right" aria-hidden="true"></i>';
          item0[0].textContent = this.props.configurations[
            "MedicoPersonalPestaña"
          ];
        } else {
          tabList[1].style.cssText = "width: 60%;left: 20%;";
          tabList[0].style.cssText = "width: 20%; left: 0%; ;";
          item0[0].textContent = " ";
          item0[0].innerHTML =
            '<i class="fa fa-chevron-left" aria-hidden="true"></i>';
          item1[0].textContent = this.props.configurations[
            "BeneficiariosPestaña"
          ];
        }
      }
    }
  }

  render() {
    const titleGenerator = (text, direction) => (
      <p>
        <span className="tab-title">{text}</span>
        <span className={`fa fa-angle-${direction}`} />
      </p>
    );
    return (
      <div id="doctor-container" className="doctor-container">
        <div>
          {this.state.currentAlert === "messages" ? (
            <Mensajes
              msg={this.state.configurations["MensajeErrorDeServicios"]}
            />
          ) : null}
        </div>
        {!this.state.isDoctorAssigned &&
        this.state.typeUser === "CE" &&
        (this.props.configurations["TituloAsignarMedicoCSVisibleBool"] ||
          this.props.configurations["TextoAsignarMedicoCSVisibleBool"] ||
          this.props.configurations["BotonAsignarMedicoCSVisibleBool"]) ? (
          <div className="assign-doctor-container row">
            <div className="col-sm-12">
              <div className="assign-doctor-intro">
                <div className="icon-warining">
                  <i className="fa fa-warning" />
                </div>
                <div className="assign-text">
                  {this.props.configurations[
                    "TituloAsignarMedicoCSVisibleBool"
                  ] ? (
                    <h2 className="title-intro">
                      {this.props.configurations["TituloAsignarMedico"]}
                    </h2>
                  ) : null}
                  {this.props.configurations[
                    "TextoAsignarMedicoCSVisibleBool"
                  ] ? (
                    <p>{this.props.configurations["TextoAsignarMedico"]}</p>
                  ) : null}
                  {this.props.configurations[
                    "BotonAsignarMedicoCSVisibleBool"
                  ] ? (
                    <button type="button" className="btn btn-primary">
                      {this.props.configurations["BotonAsignarMedico"]}
                    </button>
                  ) : null}
                </div>
              </div>
              <hr className="hr-line-div-elem" />
            </div>
          </div>
        ) : null}
        <div className="doctor-tabs-container row">
          <div className="col-sm-12">
            <div
              className={
                "loadingWraper loadingWraper--" +
                (this.state.loadingDoctorInfo ? "visible" : "hidden")
              }
            >
              <div className="compensarLoading">
                <span>cargando...</span>
              </div>
            </div>
            <div className="cs-tabs-container">
              <Tabs
                activeKey={this.state.key}
                onSelect={this.tabSelect}
                id="doctor-tabs"
              >
                <Tab
                  eventKey={1}
                  title={titleGenerator(
                    this.props.configurations["MedicoPersonalPestaña"],
                    "left"
                  )}
                >
                  <MedicoPersonal
                    key="-1"
                    configurations={this.props.configurations}
                    userDocumentType={this.props.userInfo.TipoIdentificacion}
                    userDocumentNumber={this.props.userInfo.LegalID}
                    getDoctorInfo={this.getDoctorInfo}
                    user={this.state.userContributor}
                    typeUser={this.state.typeUser}
                  />
                </Tab>
                {(this.state.beneficiariesList &&
                  this.state.beneficiariesList.length > 0) ||
                this.state.showBeneficiariesTab ? (
                  <Tab
                    eventKey={2}
                    title={titleGenerator(
                      this.props.configurations["BeneficiariosPestaña"],
                      "right"
                    )}
                  >
                    <div className="tab-container">
                      <p>{this.state.benefiariesServiceErrorMessage}</p>
                      <PanelGroup
                        accordion
                        className="cs-accordeon"
                        id="accordion-medical-equipment"
                        activeKey={this.state.activeOption}
                        onSelect={this.beneficiariesHandleSelect}
                      >
                        {this.state.beneficiariesList.map((beneficiary, i) => {
                          return (
                            <Panel eventKey={i} key={i}>
                              <Panel.Heading>
                                <Panel.Title toggle>
                                  <h5
                                    className={
                                      this.state.activeOption === i
                                        ? "active-title"
                                        : "inactive-title"
                                    }
                                  >
                                    {" "}
                                    {beneficiary.Nombre}{" "}
                                  </h5>
                                  <div
                                    className={
                                      "accordion-icon " +
                                      (this.state.activeOption === i
                                        ? "active"
                                        : "")
                                    }
                                  >
                                    <i
                                      className={
                                        "fa " +
                                        (this.state.activeOption === i
                                          ? "fa-chevron-circle-up"
                                          : "fa-chevron-circle-down")
                                      }
                                    />
                                  </div>
                                </Panel.Title>
                              </Panel.Heading>
                              <Panel.Body collapsible>
                                {this.state.activeOption === i ? (
                                  <MedicoPersonal
                                    key={i}
                                    configurations={this.state.configurations}
                                    userDocumentType={
                                      beneficiary.TipoDeDocumento
                                    }
                                    userDocumentNumber={
                                      beneficiary.NumeroDeDocumento
                                    }
                                    getDoctorInfo={this.getDoctorInfo}
                                    user={this.state.userBeneficiary}
                                    typeUser={this.state.typeUser}
                                  />
                                ) : null}
                              </Panel.Body>
                            </Panel>
                          );
                        })}
                      </PanelGroup>
                    </div>
                  </Tab>
                ) : null}
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

/******************** BUILD ********************/
const Tabs = ReactBootstrap.Tabs;
const Tab = ReactBootstrap.Tab;
const PanelGroup = ReactBootstrap.PanelGroup;
const Panel = ReactBootstrap.Panel;
/******************** BUILD ********************/

export default SedeMedicoPersonal;



// WEBPACK FOOTER //
// ./salidaGraficaRed/miRedDeAtencion/miSedeMedicoPersonal/src/components/sedeMedicoPersonal.js